import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'app-email-summary-field',
    templateUrl: './email-summary-field.component.html',
})
export class EmailSummaryFieldComponent implements OnInit {

    @Input() email: string;

    constructor() {
    }

    ngOnInit() {
    }

}
